module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CY - Cyprus.c5d47a5b.svg";